/* tslint:disable */

declare var Object: any;
export interface PaymentServiceInterface {
  "id"?: number;
}

export class PaymentService implements PaymentServiceInterface {
  "id": number;
  constructor(data?: PaymentServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PaymentService`.
   */
  public static getModelName() {
    return "PaymentService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PaymentService for dynamic purposes.
  **/
  public static factory(data: PaymentServiceInterface): PaymentService{
    return new PaymentService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PaymentService',
      plural: 'PaymentServices',
      path: 'PaymentServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/PaymentService.ts